export default "__VITE_ASSET__BJ9NncJl__"